// messages
export const MSG_NO_DATA = { SHORT: "No data", LONG: "There is no data" };
export const MSG_CONNECTING_SERVER = {
  SHORT: "Connecting...",
  LONG: "Connecting to the server...",
};

export const MSG_LOGIN_SUCCESS = {
  SHORT: "Successfully Logged in",
  LONG: "Successfully Logged in",
};

export const MSG_LOGIN_FAIL = {
  SHORT: "Email or Password is incorrect",
  LONG: "Email or Password is incorrect",
};

export const MSG_AUTO_LOGIN_FAIL = {
  SHORT: "Sorry, failed to log in automatically.",
  LONG: "Sorry, failed to log in automatically. Please log in manually.",
};

export const MSG_REGISTER_SUCCESS = {
  SHORT: "Successfully registered",
  LONG: "Successfully registered an account",
};

export const MSG_REGISTER_FAIL = {
  SHORT: "Register failed",
  LONG: "Register failed",
};

export const MSG_INPUT_ALL = {
  SHORT: "Fill all fields correctly.",
  LONG: "Please fill all fields correctly.",
};

export const MSG_EMAIL_DUPLICATE = {
  SHORT: "Email duplicated.",
  LONG: "Email is already taken",
};
// validation err
export const ERR_VALIDATION_EMAIL = {
  SHORT: "Email address is not correct format!",
  LONG: "Email address is not correct format!",
};

export const ERR_VALIDATION_ADDRESS = {
  SHORT: "Please select correct address!",
  LONG: "Please select correct address!",
};

export const ERR_VALIDATION_TEXT = {
  SHORT: "This field is required!",
  LONG: "This field is required!",
};

export const ERR_PASSWORD_INCORRECT = {
  SHORT: "Password is incorrect!",
  LONG: "Password is incorrect!",
};

export const ERR_PASSWORD_CONFIRM = {
  SHORT: "Password does not match!",
  LONG: "Password does not match!",
};

export const ERR_NETWORK = {
  SHORT: "Network connection failed",
  LONG: "Network connection failed. please check your connection.",
};
